import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const STEPS = [
  { label:'Initializing secure connection…',   pct:12 },
  { label:'Verifying your identity…',           pct:28 },
  { label:'Checking credit profile…',           pct:44 },
  { label:'Analyzing M-Pesa history…',          pct:58 },
  { label:'Calculating loan offer…',            pct:67 },
  { label:'Preparing your results…',            pct:80 },
  { label:'Finalizing approval…',               pct:93 },
  { label:'Almost done…',                       pct:100 },
];

export default function Processing() {
  const [idx, setIdx] = useState(0);
  const navigate = useNavigate();
  const { state } = useLocation();
  const applicantData = state?.applicantData || {};

  useEffect(() => {
    const iv = setInterval(() => setIdx(p => p < STEPS.length-1 ? p+1 : p), 950);
    const to = setTimeout(() => navigate('/offers', { state: { applicantData } }), STEPS.length*950+600);
    return () => { clearInterval(iv); clearTimeout(to); };
  }, []);

  const cur = STEPS[idx];
  return (
    <div className="processing-page">
      <div className="processing-card">
        <div className="secure-pill">🔒 Secure Processing</div>
        <h2 className="proc-title">Processing Your<br />Application</h2>
        <div className="ssl-chip"><span style={{color:'var(--red-500)'}}>✓</span> 256-bit SSL Encryption</div>
        <div className="dots"><div className="dot"/><div className="dot"/><div className="dot"/></div>
        <p className="proc-status">{cur.label}</p>
        <div className="prog-wrap">
          <div className="prog-labels"><span>Progress</span><span>{cur.pct}%</span></div>
          <div className="prog-track"><div className="prog-bar" style={{width:`${cur.pct}%`}}/></div>
        </div>
        <div className="proc-features">
          {[['🏛️','CBK Licensed'],['⏱️','Instant Approval'],['🔐','Data Protected'],['💳','No Hidden Fees']].map(([icon,label]) => (
            <div className="proc-feat" key={label}><span className="proc-feat-icon">{icon}</span>{label}</div>
          ))}
        </div>
      </div>
    </div>
  );
}
